module.exports = __webpack_public_path__ + "img/vehicle_3.43461a63.png";